<template>
  <v-navigation-drawer
    :value="value"
    app
    temporary
    floating
    class="accent"
    @input="$emit('input', $event)"
  >
    <h-logo width="220" height="28" class="mt-6 mb-4 ml-4" @click="close()" />
    <div v-if="isDemoUser" class="ml-4 mt-n6 text-subtitle-2">
      <i>Versión <b>DEMO</b></i>
    </div>
    <v-list nav dense>

      <v-list-item @click="drawerSync()">
        <v-list-item-icon>
          <h-sync-icon />
        </v-list-item-icon>
        <v-list-item-title>{{ __('resync') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="open('history')">
        <v-list-item-icon>
          <v-icon v-text="icons.history" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('history') }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="showTpvMode" @click="enableTpvMode()">
        <v-list-item-icon>
          <v-icon v-text="icons.tpvMode" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('tpvMode') }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="showEventMode" @click="toggleEventMode()">
        <v-list-item-icon>
          <v-icon :color="eventModeColor" v-text="icons.eventMode" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('eventMode') }}</v-list-item-title>
      </v-list-item>

      <h-cash-control
        v-model="cashControl"
        @open="open"
        @close="close"
      />

      <v-list-item v-if="can('deviceConfig')" @click="open('settings')">
        <v-list-item-icon>
          <v-icon v-text="icons.preferences" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('settings') }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="hasFiscalInfo" @click="open('fiscalCountry')">
        <v-list-item-icon>
          <v-icon v-text="icons.fiscal" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('fiscalInformation') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="open('help')">
        <v-list-item-icon>
          <v-icon v-text="icons.help" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('needHelp') }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="showLogout" @click="closeAndLogout()">
        <v-list-item-icon>
          <v-icon v-text="icons.logout" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('logout') }}</v-list-item-title>
      </v-list-item>

    </v-list>
    <div v-if="isDemoUser" class="mx-4 mt-16">
      <p class="text-body-2 font-weight-bold">Disfruta de la experiencia completa</p>
      <v-btn
        depressed
        color="primary"
        class="text-none"
        @click="open('purchase')"
      >
        Smart Business LITE
      </v-btn>
    </div>
    <v-footer absolute color="transparent">
      <h-version top />
      <v-spacer />
      <h-by-revo />
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import InteractsWithLoading from '@/Mixins/InteractsWithLoading'
  import Loggable from '@/Mixins/Loggable'
  import Logout from '@/Mixins/AuthLogout'
  import NeedsPermission from '@/Mixins/NeedsPermission'
  import Synchronizable from '@/Mixins/Synchronizable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import FranceLog from '@/Models/Static/FiscalCountry/FranceLog'
  import HLogo from '@/Components/Logo/Brand'
  import HByRevo from '@/Components/Logo/ByRevo'
  import HVersion from '@/Components/Version'
  import HSyncIcon from './SyncIcon'
  import HCashControl from './CashControl'

  export default {
    mixins: [
      I18n,
      InteractsWithLoading,
      Loggable,
      Logout,
      NeedsPermission,
      Synchronizable,
      UsesIcons,
    ],

    components: {
      HLogo,
      HByRevo,
      HVersion,
      HSyncIcon,
      HCashControl,
    },

    props: {
      value: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      FranceLog,
      cashControl: false,
    }),

    computed: {
      isDemoUser () {
        return this.$page.props.auth.demo
      },
      showLogout () {
        return ! this.isDemoUser && this.can('logout')
      },
      hasFiscalInfo () {
        return this.$store.getters['fiscalCountry/info']?.length > 0
      },
      ...mapGetters('workingModes', [
        'showTpvMode',
        'showEventMode'
      ]),
      eventModeColor () {
        return this.$store.state.workingModes.event ? 'primary' : null
      },
    },

    watch: {
      value (v) {
        if (! v) {
          this.cashControl = false
        }
      },
    },

    methods: {
      open (action) {
        this.$store.dispatch(`${action}/open`)
        this.close()
      },
      async drawerSync () {
        await this.syncAll()
        this.close()
      },
      enableTpvMode () {
        this.$store.commit('sync/skip')
        this.$store.commit('workingModes/enableTpvMode')
        this.close()
      },
      toggleEventMode () {
        this.$store.commit('workingModes/toggleEventMode')
        this.close()
      },
      async closeAndLogout () {
        this.close()
        this.startLoading()
        this.$log('Logout')
        this.$logFrance(this.FranceLog.TERMINAL_SHUT_DOWN)
        await this.sendLogFromSpa()
        this.stopLoading()
        this.logout()
      },
      close () {
        this.$emit('input', false)
      },
    },
  }
</script>
